export default {"src":"/_next/static/media/HERO.12db2b98.svg","height":18,"width":18};